import React, { useState } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import Str from "shared/components/Str";
import MessagesIcon from "shared/components/svgs/Messages.svg";

import Dropdown from "apps/messages/components/Dropdown";
import {
	selectedOptionOnNavBarEvent,
} from "./analytics";

const MessagesButton = ({ isSelected, messagesCount }) => {
	const [isDropdownOpen, setIsDropdownOpen] = useState(false);
	const open = () => setIsDropdownOpen(true);

	return (
		<div className="navbar-message">
			<button
				className="navbar-message-btn"
				onClick={() => {
					if (isDropdownOpen) {
						return;
					}

					selectedOptionOnNavBarEvent("Conversations Dropdown");
					open();
				}}
			>
				<div className="navbar-message-btn-container">
					<div className="navbar-link-icon-container" >
						<MessagesIcon
							className={classnames("navbar-icon", {
								"navbar-icon-selected": isSelected,
							})}
							width={24}
							height={24}
						/>
						<div
							className={classnames("navbar-underline", {
								"navbar-underline-selected": isSelected,
							})}
						/>
						{/**
							 * Mailbox inbox count can be jQuery-ed in via InstantEvents.
							 * Need id="navbar-mailbox" so that the count
							 * can be injected into the dom.
						*/}
						<div id={messagesCount !== null ? "" : "navbar-mailbox"}>
							{
								messagesCount
									? (
										<div className="badge navbar-likes-count">
											<span className="count">
												{messagesCount > 99 ? "99+" : messagesCount}
											</span>
										</div>
									)
									: null
							}
						</div>
					</div>
					<span className="navbar-text">
						<Str>Messages</Str>
					</span>
				</div>
			</button>
			<Dropdown
				isOpen={isDropdownOpen}
				setIsOpen={setIsDropdownOpen}
			/>
		</div>
	);
};

MessagesButton.defaultProps = {
	isSelected: false,
	messagesCount: null,
};

MessagesButton.propTypes = {
	isSelected: PropTypes.bool,
	messagesCount: PropTypes.number,
};

export default MessagesButton;



// WEBPACK FOOTER //
// ./src/shared/components/NavBar/MessagesButton.jsx